import Span from 'src/components/atomic/atom/Span'
import Button from 'src/components/atomic/atom/Button'
import Image from 'src/components/atomic/atom/Image'
import Div from 'src/components/atomic/atom/Div'
import Svg from 'src/components/atomic/atom/Svg'
import { COLOR } from 'src/constants/colors'
import useMediaQueryHook from 'src/hooks/useMediaQuery.hook'
import { useTranslation } from 'react-i18next'
import { SettingDataPropsType } from 'src/views/Service/Setting'
import { useAppSelector } from 'src/hooks/redux/useAppSelector'
import { RootState } from 'src/store/store'
import google_logo from 'src/assets/imgs/logo/google.png'
import facebook_logo from 'src/assets/imgs/logo/facebook.png'
import SessionStorageUtils from 'src/utils/SessionStorage.utils'
import { commonUtils } from 'src/utils/common.utils'
import { SNSLoginType } from 'src/store/Reducer/page/loginPageSlice'

const SettingTemplate = (props: { data: SettingDataPropsType }) => {
  const { SettingList } = props.data
  const { Name } = useAppSelector((state: RootState) => state.HomePage)
  const { t } = useTranslation()
  const { setMediaStyle } = useMediaQueryHook()
  const { getStorageData } = SessionStorageUtils()
  const userData = getStorageData('userInfo')

  return (
    <>
      <Span
        option={setMediaStyle('extraLarge_bold', 'mediumLarge_bold', 'mediumLarge_bold')}
        $margin={'32px auto 20px auto'}
        $text_align={'left'}
      >
        {t('SETTING.TITLE', { defaultValue: 'Hi' })},
        <br /> {Name}.
      </Span>
      <Span color={COLOR.black40} option={'tiny_bold'} $text_align={'left'}>
        {t('SETTING.DESC', { defaultValue: 'Signed in MFinder Account' })}
      </Span>
      <Button
        option={'bigIconText'}
        $bgColor={`${COLOR.black2} !important`}
        $margin={'12px auto'}
        style={{ cursor: 'default' }}
      >
        {userData?.SNSType === SNSLoginType.GOOGLE ? (
          <Image $ImgSrc={google_logo} width={'20px'} height={'20px'} />
        ) : (
          <Image $ImgSrc={facebook_logo} width={'20px'} height={'20px'} />
        )}
        <Span
          option={setMediaStyle('medium_bold', 'small_bold', 'small_bold')}
          $margin={'0 20px'}
          $text_align={'left'}
        >
          {userData?.Email}
        </Span>
      </Button>
      <Button
        className={'setting_Mfinder_plan'}
        height={setMediaStyle('52px', '48px', '48px')}
        $border={`1px solid ${COLOR.brand}`}
        onClick={() =>
          commonUtils.OpenExternalPage('https://play.google.com/store/account/subscriptions?pli=1')
        }
      >
        <Span option={setMediaStyle('medium_bold', 'small_bold', 'small_bold')} color={COLOR.brand}>
          MFinder Plan
        </Span>
      </Button>
      <Div display={'flex'} $flex_wrap={'wrap'} $gap={'8px'} $margin={'20px auto'}>
        {SettingList.map((element) => (
          <Button
            key={element.text}
            option={'bigIconText'}
            $bgColor={COLOR.black2}
            onClick={element.onClickFunc}
            className={element.className}
          >
            <Svg name={element.svg} />
            <Span
              option={setMediaStyle('medium_bold', 'small_bold', 'small_bold')}
              $text_align={'left'}
              $margin={'0 20px'}
            >
              {element.text}
            </Span>
            <Svg name={'arrow'} />
          </Button>
        ))}
      </Div>
    </>
  )
}
export default SettingTemplate
